import { useMatch } from 'react-router-dom';

import { Optional } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';
import { store } from '@store';
import { EHR_PAGE_PATH } from '@patient/routes/consts';

// store.ehr переживает уход с карты пациента, поэтому его id годится только когда он совпадает
// с картой, открытой в адресной строке (в url бывает и id, и номер карты).
export function useOpenedEhrId(): Optional<string> {
    const routePatientId = useMatch(`${EHR_PAGE_PATH}/*`)?.params.patientId;
    const { id, recordId } = store.ehr;

    const isCurrentEhrLoaded =
        isDefined(routePatientId) && (routePatientId === id || routePatientId === String(recordId));

    return isCurrentEhrLoaded ? id : undefined;
}
